<template>
  <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
    <canvas :id="uuid" :width="size.width" :height="size.height"/>
  </div>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {Colorize, palette} from "@/libs/colorizer";


export default {
  name: "dc768591-0d39-11eb-8114-00155d01060e",
  props: ['chart', 'size', 'title', 'uuid', 'test'],
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      canvas: null,
      graph: null,
      names: [],
      counters: [],
      problems: []
    }
  },
  computed: {
    report_data() {
      return this.chart.report_data
    },
    palette() {
      return palette
    },
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  methods: {
    Colorize,
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.names,
            datasets: this.counters
          },
          options: {
            plugins: {
              legend: {
                position: 'top',
                align: 'center'
              },
              datalabels: {
                color: function (value) {
                  return Colorize(value.dataset.backgroundColor)
                },
                anchor: 'center',
                clamp: true,
                align: 'center',
                formatter: function (value) {
                  if (value > 0) return Math.ceil(value)
                  return null
                }
              }
            },
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true,
                title: {
                  display: true,
                  text: 'Кол-во испытаний'
                },
                beginAtZero: true
              }
            }
          }
        })
      }
    },
    update_data: function () {
      this.names = ["Количество замечаний", "План", "Факт"]

      let errors = 0
      let plan = 0
      let fact = [0, 0]

      this.chart.report_data.map(el => {

        switch (el['Тип']) {
          case 'План':
            plan += el['КоличествоИспытаний']
            break;
          case 'Факт':
            switch (el['Расшифровка']) {
              case 'Без замечаний':
                fact[0] += el['КоличествоИспытаний']
                break;
              default:
                fact[1] += el['КоличествоИспытаний']
                break;
            }
            break;
          case 'КоличествоНеиспраностей':
            if (el['Ссылка']) {
              this.problems.push({
                id: el['Ссылка'],
                number: el['СсылкаНомер'],
                description: el['Описание']
              })
            }
            errors++
            break;
        }
      })
      this.counters = [
        {
          label: 'Замечания',
          maxBarThickness: 800,
          data: [errors, null, null]
        },
        {
          label: 'План',
          maxBarThickness: 800,
          data: [null, plan, null]
        },
        {
          label: 'Факт - без замечаний',
          maxBarThickness: 800,
          data: [null, null, fact[0]]
        },
        {
          label: 'Факт - с замечаниями',
          maxBarThickness: 800,
          data: [null, null, fact[1]]
        }
      ]
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  }
}
</script>